export default __webpack_public_path__ + "static/media/rhenus-mrc.7d13b4f7.svg";